(() => {
  const ids = new Set([15425130594486,15425130627254]);
  const property = 'Garment testing acknowledgment';
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  function accepted(id) { try { return JSON.parse(sessionStorage.getItem('sb-ack-'+id) || 'null'); } catch { return null; } }
  function remember(id,text) { try { sessionStorage.setItem('sb-ack-'+id,JSON.stringify({text,at:new Date().toISOString()})); } catch {} }
  function gatePage(event) {
    const target = event.target;
    const box = document.querySelector('[data-sb-ack]');
    if (!box || !target.closest) return;
    const relevant = event.type==='submit' ? target.id===box.form?.id : target.closest('#gs-builder-btn, .product-info__buy-buttons button[type="submit"]');
    if (!relevant) return;
    if (!box.checked) {
      event.preventDefault();event.stopImmediatePropagation();
      const error=box.closest('.sb-ack').querySelector('.sb-error');error.hidden=false;box.focus();box.reportValidity();
    } else remember(Number(box.closest('[data-sb-product]').dataset.sbProduct),box.value);
  }
  document.addEventListener('click',gatePage,true);
  document.addEventListener('submit',gatePage,true);
  document.addEventListener('change',event=>{
    if (!event.target.matches('[data-sb-ack]')) return;
    const box=event.target;box.closest('.sb-ack').querySelector('.sb-error').hidden=box.checked;
  });
  document.addEventListener('click',event=>{
    const a=event.target.closest?.('.sb-choice');if(!a)return;
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    if(preview){const u=new URL(a.href);u.searchParams.set('preview_theme_id',preview);a.href=u.href;}
  });
  async function cart() { const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});if(!r.ok)throw Error('cart');return r.json(); }
  async function attach(current,text) {
    for(const item of current.items.filter(item=>ids.has(item.product_id)&&item.properties?.[property]!==text)) {
      const r=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:item.key,quantity:item.quantity,properties:{...item.properties,[property]:text,'_specialty_bond_ack_version':'2026-10-18','_specialty_bond_ack_at':new Date().toISOString()}})});
      if(!r.ok)throw Error('save');
    }
  }
  async function checkout(event) {
    const target=event.target;
    const hit=event.type==='submit' ? event.submitter?.matches('[name="checkout"]') : target.closest?.('[name="checkout"],a[href="/checkout"],a[href^="/checkout?"]');
    if(!hit)return;
    event.preventDefault();event.stopImmediatePropagation();if(busy)return;busy=true;
    const modal=document.querySelector('[data-sb-dialog]');
    try {
      const current=await cart();const special=current.items.filter(item=>ids.has(item.product_id));
      if(!special.length){location.assign(root+'checkout');return;}
      const text=modal.querySelector('[data-sb-cart-ack]').value;
      const missing=special.filter(item=>item.properties?.[property]!==text);
      if(!missing.length){location.assign(root+'checkout');return;}
      if(missing.every(item=>accepted(item.product_id)?.text===text)){await attach(current,text);location.assign(root+'checkout');return;}
      modal.showModal();modal.querySelector('[data-sb-cart-ack]').checked=false;modal.querySelector('[data-sb-cart-ack]').focus();busy=false;
    } catch {
      if(modal){modal.showModal();modal.querySelector('[data-sb-save-error]').hidden=false;}busy=false;
    }
  }
  document.addEventListener('click',checkout,true);
  document.addEventListener('submit',checkout,true);
  document.addEventListener('click',async event=>{
    if(event.target.matches('[data-sb-cancel]')){event.target.closest('dialog').close();return;}
    if(!event.target.matches('[data-sb-confirm]'))return;
    const modal=event.target.closest('dialog'),check=modal.querySelector('[data-sb-cart-ack]');
    if(!check.reportValidity())return;if(busy)return;busy=true;event.target.disabled=true;
    try{const current=await cart();await attach(current,check.value);location.assign(root+'checkout');}
    catch{modal.querySelector('[data-sb-save-error]').hidden=false;busy=false;event.target.disabled=false;}
  });
})();
